const IconArrow = () => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 122.83 82.83"
    >
        <polyline points="80 1.41 120 41.41 80 81.41" />
        <line x1="120" y1="41.41" y2="41.41" />
    </svg>
)

export default IconArrow
